import GeneralSchema from "@/Config/Export/CreateNewCustomer/GeneralAddress";
import MoreAddress from "@/Config/Export/CreateNewCustomer/MoreAddress";
import CreateContact from "@/Config/Export/CreateNewCustomer/CreateContact";
import ConsigneeSchema from "../../../Config/Export/CreateNewCustomer/Consignee";
import ShipperSchema from "../../../Config/Export/CreateNewCustomer/Shipper";
import CarrierSchema from "../../../Config/Export/CreateNewCustomer/NewCustomerCarrier";
import ServicesSchema from "../../../Config/Export/CreateNewCustomer/Services";
import FreightJobSharingSchema from "../../../Config/Export/CreateNewCustomer/Integrations/FreightJobSharing";
import customeExportFreightJobSharingSchema from "../../../Config/Export/CreateNewCustomer/Integrations/customeExportFreightJobSharing";
import CustomImportFreightJobSharingSchema from "../../../Config/Export/CreateNewCustomer/Integrations/CustomImportFreightJobSharing ";
import InvoiceSharingSchema from "../../../Config/Export/CreateNewCustomer/Integrations/InvoiceSharing";
import GeneralInformationSchema from "../../../Config/Export/CreateNewCustomer/KYC/KycGeneralInfo";
import AddressSchema from "../../../Config/Export/CreateNewCustomer/KYC/KycAddress";
import AuthorizedSchema from "../../../Config/Export/CreateNewCustomer/KYC/Authorized";
import DocumentsSchema from "../../../Config/Export/CreateNewCustomer/KYC/Document";
import customerSchema from "../../../Config/Export/CreateNewCustomer/CustomerAddressFilter";
import Shipper from "../../../Config/Export/CreateNewCustomer/Shipper";
import Note from "./Note/Note";
import bankdealer from "./CustomeDetails/Bankdealer/bankdealer";
import KycGeneralInfo from "../../../Config/Export/CreateNewCustomer/KYC/KycGeneralInfo";
import drawbackdetails from "./CustomeDetails/DrawBackdetails/drawbackdetails";
import Agentform from "@/Views/ImportJob/CreateNewCustomer/Agent/Agentform";
import regSchema from "./../../../Config/Export/CreateNewCustomer/Reg";
import { normalizeBlocks } from "@/redux/mappers/Customer/KycAuthoriser/KycAutoriseSignator";
import { mapAgentReq } from "@/redux/mappers/Customer/Agent/AgentMapper";

import AeoSchema from "../../../Config/Export/CreateNewCustomer/CustomeDetails/AEODetails/Aeodetails";
import markSchema from "../../../Config/Export/CreateNewCustomer/CustomeDetails/Marks/marks"
import NewCustomerCarrier from "../../../Config/Export/CreateNewCustomer/NewCustomerCarrier";
import CustomMasterForm from "@/Views/ExportJob/CreateNewCustomer/CustomMaster/CustomMasterForm";
import {mapKycDocument} from "./../../../redux/mappers/Customer/DocumentMapper"
export const CreateNewJobSidebarItems = (formData) => {
  const hasJobNumber = formData?.general?.exporterJobNumber ?? false;
  const hasCusomerid =
    formData?.general?.customerId === true ||
    (formData?.invoiceMain?.length ?? 0) > 0;
  const hasProduct = formData?.productMain?.length != 0 ? true : false;
  const selectedTypes = Array.isArray(formData?.customer?.entityTypes)
    ? formData.customer.entityTypes.map((t) => t.label?.toLowerCase())
    : [];

  const selectedInvoice =
    formData?.invoiceMain?.find((invoice) => invoice?.selected === true) ||
    null;

  const eximCode = formData?.productGeneral?.exportProductGeneralEximCode;
  const firstInvoice = formData?.invoiceMain?.[0];
  const currencyName = firstInvoice?.exportCurrency?.name || "-";

  return [
    {
      id: "general",
      label: "General",
      type: "tab",
      subTabs: [
        {
          id: "GeneralAddress",
          label: "General",
          schema: GeneralSchema,
          api: "GeneralAddress",
          type: "table",
          visibleFields: [
            { key: "customerBranchName", label: "BranchName", width: 100 },
            { key: "customerAddressLine", label: "Address", width: 150 },
            { key: "countryId", label: "Country", width: 150 },
            { key: "stateId", label: "State", width: 150 },
            { key: "cityId", label: "City", width: 250 },
            {
              key: "customerAddressPostalCode",
              label: "Postal Code",
              width: 150,
            },
            { key: "customerAddressFax", label: "Fax", width: 150 },
          ],
          expandedFields: [
            { key: "customerAddressTelephone", label: "Telephone", width: 100 },
            { key: "customerAddressWebsite", label: "Website", width: 100 },
            { key: "customerAddressEmailAddress", label: "Email", width: 100 },
            {
              key: "customerAddressSalesPerson",
              label: "Sales Persion",
              width: 100,
            },
            { key: "customerAddressTaxableType", label: "Type", width: 100 },
          ],
        },
        {
          id: "moreAddress",
          label: "More Address",
          schema: MoreAddress,
          api: "MoreAddress",
          replaceMasterId: "GeneralAddress",
          type: "table",
          visibleFields: [
            { key: "customerAddressType", label: "Type", width: 100 },
            { key: "customerName", label: "Name", width: 150 },
            { key: "customerState", label: "Mobile", width: 150 },
            { key: "customerCity", label: "Address", width: 250 },
            { key: "customerPostalCode", label: "Country", width: 150 },
            { key: "customerFax", label: "City", width: 150 },
          ],
          expandedFields: [
            { key: "customerTelephone", label: "Fax", width: 100 },
            { key: "customerEmailAddress", label: "Email", width: 100 },
          ],
        },

        {
          id: "contact",
          label: "Contact",
          schema: CreateContact,
          api: "Contact",
          type: "table",
          replaceMasterId: "GeneralAddress",
          visibleFields: [
            { key: "contactName", label: "ContactName", width: 100 },
            { key: "contactDepartment", label: "Department", width: 150 },
            { key: "contactEmail", label: "Email", width: 150 },
            { key: "contactMobile", label: "Mobile", width: 150 },
            { key: "contactTelephone", label: "Telephone", width: 250 },
            { key: "contactTitle", label: "Title", width: 150 },
          ],
        },
        {
          id: "customdetails",
          // replaceMasterId: "GeneralAddress",
          label: "Custom Details",
          type: "tab", 
          hasComponent: true,      // ⭐ important
          component:CustomMasterForm,
          subTabs: [
            {
              id: "bankdealer",
              label: "Bankdealer",
              schema: bankdealer,
              type: "table",
              extraApi:"CustomDetails",
              api: "bankdealer",
              visibleFields: [
                {
                  key: "customeBankDealerEntityName",
                  label: "Bank Name",
                  width: 100,
                },
                { key: "customeBankDealerACNo", label: "Ac No", width: 150 },
                {
                  key: "customeBankDealerADCode",
                  label: "AD Code",
                  width: 150,
                },
              ],
              buttons: [{ label: "Add", icon: "LuPlus", onClick: "openForm" }],

            },

            {
              id: "drawbackdetails",
              label: "DrawBack Details",
              type: "form",
              schema: drawbackdetails,
              api:"Drawbackdetails"
              
            },

            {
              id: "aeodetails",
              label: "AEO details",
              type: "table",
              buttons: [{ label: "Add", icon: "LuPlus", onClick: "openForm" }],
              schema: AeoSchema,
              api: "AeoDetails",
              replaceMasterId: "GeneralAddress",
              visibleFields: [
                { key: "aeoCode", label: "AEO Code", width: 100 },
                { key: "aeoCountry", label: "AEO Country", width: 150 },
                { key: "aeoRole", label: "AEO ROleail", width: 150 },
              ],
            },
            {
              id: "esanchit",
              label: "eSanchit",
              type: "table",
              buttons: [{ label: "Add", icon: "LuPlus", onClick: "openForm" }],
            },
            {
              id: "Marksandno",
              label: "Marks & No.",
              type: "form",
              schema: markSchema,
            },
          ],
        },
      ],
      buttons: [
        {
          id : "newAddress",
          label: "New Address",
          icon: "LuPlus",
          onClick: "openForm",
        },
      ],
    },

    {
      id: "shipper",
      label: "Shipper",
      api: "shiper",
      type: "form",
      schema: Shipper,
      disabled: !selectedTypes.includes("shipper"),
    },
    {
      id: "consignee",
      label: "Consignee",
      api: "consignee",
      type: "form",
      schema: ConsigneeSchema,
      disabled: !selectedTypes.includes("consignee"),
    },

    {
      id: "agent",
      label: "Agent",
      // schema: Sezinfo,
      type: "component",
      api: "agentApi",
      // disabled: true,
      component : Agentform,
      mapper : mapAgentReq
    },
    {
      id: "services",
      label: "Services",
      type: "form",
      schema: ServicesSchema,
      api: "service",
      disabled: !selectedTypes.includes("services"),
    },
    {
      id: "carrier",
      label: "Carrier",
      type: "form",
      schema: NewCustomerCarrier,
      api:"carrier"

    },
    {
      id: "reg",
      label: "Reg",
      type: "table",
      schema: regSchema,
      subButtons: [{ label: "Add", icon: "LuPlus", onClick: "openForm" }],
      visibleFields: [
        { key: "registrationType", label: "Reg Type" },
        { key: "registrationNo", label: "Reg Number" },
        { key: "branch", label: "Branch" },
        { key: "registrationDate", label: "Registration Date" },
        { key: "validUpto", label: "Valited Up To" },
      ],
      api: "CustomerReg",
    },
    {
      id: "integration",
      label: "Integration",
      type: "tab",
      disabled: true,
      subTabs: [
        {
          id: "frieghtjobsharing",
          label: "Frieght Job Sharing",
          schema: FreightJobSharingSchema,
          // api: "frieghtjobsharing",
          type: "form",
        },
        {
          id: "customerexportjobsharing",
          label: "Customer Export Job Sharing",
          schema: customeExportFreightJobSharingSchema,
          // api: "exporter",
          type: "form",
        },
        {
          id: "customerimportjobbsharing",
          label: "Customer Import Job Sharing",
          schema: CustomImportFreightJobSharingSchema,
          // api: "exporter",
          type: "form",
        },
        {
          id: "invoicesharing",
          label: "Invoice Sharing",
          schema: InvoiceSharingSchema,
          // api: "exporter",
          type: "form",
        },
      ],
    },

    {
      id: "kyc",
      label: "KYC",
      type: "tab",
      checkBox: [
        {
          label: "Single Window",
        },
      ],
      subTabs: [
        {
          id: "generalinformation",
          label: "General Information",
          schema: KycGeneralInfo,
          api: "KycGeneral",
          type: "form",
        },
        {
          id: "address",
          label: "Address",
          schema: AddressSchema,
          api: "KycAddress",
          type: "form",
        },
        {
          id: "authorizedsignatory",
          label: "Authorized Signatory",
          schema: AuthorizedSchema,
          // mapper : normalizeBlocks,
          api: "KycAuthorizedSignatory",
          type: "table",
          subButtons: [{ label: "Add", icon: "LuPlus", onClick: "openForm" }],
          visibleFields: [
            { key: "name", label: "Name" },
            { key: "sex", label: "Sex" },
            { key: "dateOfBirth", label: "Date of Birth" },
            { key: "customer", label: "Customer" },
            { key: "city", label: "City" },
            { key: "state", label: "State" },
            { key: "telephone", label: "telephone" },
          ],
          // disabled : true,
          // forceArray: true,
          // needSubId : true
        },
        {
          id: "kycDocument",
          label: "Documents",
          schema: DocumentsSchema,
          api: "KYCDocuments",
          type: "form",
          mapper: mapKycDocument,   // ⭐ MUST BE ADDED
        },
      ],
    },
    {
      id: "customernote",
      label: "Notes",
      type: "table",
      schema: Note,
      api: "customerNotes",
      visibleFields: [
        { key: "customerNotesDate", label: "Date", width: 200 },
        { key: "customerNotes", label: "Notes", width: 200 },
      ],

      subButtons: [
        {
          label: "Add Notes",
          icon: "LuPlus",
          onClick: "openForm",
        },
      ],
    },
    {
      id: "Organizationhistory",
      label: "History",
      api: "Organizationhistory",
      type: "table",
      visibleFields: [
        { key: "customerHistoryDateTime", label: "Date & Time", width: 150 },
        { key: "userId", label: "User ID", width: 150 },
        { key: "customerHistoryLocation", label: "Location", width: 130 },
        { key: "customerHistoryAction", label: "Action", width: 130 },
        { key: "customerHistoryRemarks", label: "Remarks", width: 190 },
      ],
      actions: [],
      buttons: [
        {
          label: "Refresh",
          action: "Refresh",
        },
      ],
    },
  ];
};

export default CreateNewJobSidebarItems;
